import { render, staticRenderFns } from "./heroFour.vue?vue&type=template&id=6b2772ac&"
import script from "./heroFour.vue?vue&type=script&lang=js&"
export * from "./heroFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports